



























































































































































import moment from 'moment'
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { MensagensDaApiEnum } from '@/types/_'
import AgendaGarantiaMinimaStore from '../Store/AgendaGarantiaMinimaStore'

@Component
export default class ModalCriarEditarItemAgendaGarantiaMinimaPeriodo extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string
  menu: boolean = false

  $refs!: { formItem: any }

  formRules: any = {
    valid: true,
    nome: [(v: string) => !!v || 'Campo obrigatório'],
    data: [(v: string) => !!v || 'Campo obrigatório'],
    tipo: [(v: string) => !!v || 'Campo obrigatório'],
    observacao: [(v: string) => !!v || 'Campo obrigatório'],
  }

  loadCreateOrUpdate: boolean = false
  get loadingCreateOrUpdate() { return this.loadCreateOrUpdate }
  set loadingCreateOrUpdate(value: boolean) { this.loadCreateOrUpdate = value }

  get showModal() { return this.agendaGarantiaStore.modalItemAgendaGarantiaMinima }
  set showModal(value: boolean) { this.agendaGarantiaStore.setModal(value) }

  get agendaGarantiaStore() {
    return getModule(AgendaGarantiaMinimaStore, this.$store)
  }

  get prestadorList() {
    return this.agendaGarantiaStore.prestadoresList
  }

  get profissionaisList() {
    return this.agendaGarantiaStore.pessoaProfissionalExecutanteList
  }

  get fontePagadorasList() {
    return this.agendaGarantiaStore.fontesPagadorasList
  }

  get periodosList() {
    return this.agendaGarantiaStore.periodosList
  }

  get formattedDate() {
    const date = this.agendaGarantiaStore.itemAgendaGarantiaMinima.dataGarantia
    return date ? this.formatDateForDisplay(date) : ''
  }

  set formattedDate(value: string) {
    this.agendaGarantiaStore.itemAgendaGarantiaMinima.dataGarantia = this.formatDateForApi(value)
  }

  formatDateForDisplay(date: string) {
    try {
      const parsedDate = this.parseDate(date)
      const day = String(parsedDate.getDate()).padStart(2, '0')
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
      const year = parsedDate.getFullYear()
      return `${day}/${month}/${year}`
    } catch (error) {
      console.error('Erro ao formatar a data para exibição:', error)
      return ''
    }
  }

  formatDateForApi(date: string) {
    try {
      const [day, month, year] = date.split('-')
      if (!day || !month || !year) throw new Error('Data no formato inválido')

      const formattedDate = new Date(`${year}-${month}-${day}T00:00:00Z`)
      if (formattedDate.toString() === 'Invalid Date') {
        throw new Error('Data inválida')
      }

      return formattedDate.toISOString().split('T')[0]
    } catch (error) {
      console.error('Erro ao formatar a data para a API:', error)
      return ''
    }
  }

  parseDate(date: string) {
    if (date.includes('T')) {
      return new Date(date)
    }
    const [year, month, day] = date.split('-').map(Number)
    return new Date(year, month - 1, day)
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  async createOrUpdateItemFeriado() {
    this.loadingCreateOrUpdate = true

    if (this.$refs.formItem.validate()) {
      const request = this.mode === 'CREATE'
        ? await this.agendaGarantiaStore.createItemAgendaGarantiaMinimaPeriodo()
        : await this.agendaGarantiaStore.updateItemAgendaGarantiaMinimaPeriodo()

      if (request.success) {
        if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD && this.mode === 'EDIT') {
          EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
          this.showModal = false
          this.loadingCreateOrUpdate = false
          return
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Item de feriado ${this.mode === 'CREATE' ? 'criado' : 'atualizado'} com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.$emit('update-items-table', true)
        this.showModal = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingCreateOrUpdate = false
  }

  @Watch('showModal')
  onChangeShowModal(value) {
    if (!value) {
      this.agendaGarantiaStore.clearItemAgenda()
      this.$refs.formItem.resetValidation()
    }
  }
}
